import $ from 'jquery';
import { drawSvg } from '../common/js/FJBackgroundSVG.js';
import { isObject } from 'lodash-es';
class FJBackground {
    constructor(props) {
        props = props || {};
        this._enabled = (props && props.enabled) || false;
        this._color = (props && props.color) || '#000000';
        this._opacity = (props && props.opacity) || 1;

        this._radius = (props && props.radius) || 0;

        // 背景类型  跟随文字背景，跟随文字整体边框背景，只算padding以及文字本身的背景
        this._hasFollowText = false;
        if (props && props.hasFollowText !== undefined) {
            this._hasFollowText = props.hasFollowText;
        }

        this._padding = {
            left: 40,
            right: 40,
            top: 20,
            bottom: 20,
        };
        if (props && props.padding) this._padding = props.padding;

        if (!props || !props.pureData) {
            this.createBgElement();
            this.updateStyle();
        }
    }

    toJSON() {
        return this.encode();
    }

    fromJSON(data) {
        this.decode(data);
    }

    encode() {
        return {
            enabled: this._enabled,
            color: this._color,
            opacity: this._opacity,
            radius: this._radius,
            hasFollowText: this._hasFollowText,
            padding: this._padding,
        };
    }
    decode(data) {
        if (typeof data.enabled !== 'undefined') this._enabled = data.enabled;
        if (typeof data.color !== 'undefined') this._color = data.color;
        if (typeof data.opacity !== 'undefined') this._opacity = data.opacity;
        if (typeof data.radius !== 'undefined') this._radius = data.radius;
        if (typeof data.hasFollowText !== 'undefined') this._hasFollowText = data.hasFollowText;
        if (typeof data.padding !== 'undefined') this._padding = data.padding;
    }
    clone(object) {
        if (typeof object === 'undefined') object = new FJBackground({ pureData: true });

        object.decode(this);

        return object;
    }

    /**
     * @desc 将背景附加到对象视图上
     * @param view
     */
    addToView(view) {
        if (!view || !this._element) return;

        view.appendChild(this._element);
    }

    updateStyle() {
        if (this._enabled) {
            $(this._element).css({
                opacity: this._opacity,
            });

            let pathDom = $(this._svgBackground).find('path')[0];
            $(pathDom).attr('fill', this.color);
        } else {
            // 在禁用背景的状态下，如果存在svg背景则删除
            if (this._svgBackground) {
                $(this._svgBackground).remove();
                this._svgBackground = null;
            }
        }
    }

    /**
     * @desc 是否需要重新生成背景
     * @param {*} bk
     * @returns
     */
    isCreateBgElement(bk) {
        let ret = true;

        ret &= this._enabled == bk.enabled;
        ret &= this._radius == bk.radius;
        ret &= this._hasFollowText == bk.hasFollowText;

        return ret;
    }

    isEqual(bk) {
        let ret = true;

        ret &= this._enabled == bk.enabled;
        ret &= this._color == bk.color;
        ret &= this._opacity == bk.opacity;
        ret &= this._radius == bk.radius;
        ret &= this._hasFollowText == bk.hasFollowText;
        ret &= this._padding.left == bk.padding?.left;
        ret &= this._padding.right == bk.padding?.right;
        ret &= this._padding.top == bk.padding?.top;
        ret &= this._padding.bottom == bk.padding?.bottom;

        return ret;
    }

    /**
     * @desc 隐藏背景元素
     */
    hide() {
        if (this._element) {
            $(this._element).hide();
        }
    }

    /**
     * @desc 显示背景元素
     */
    show() {
        if (this._element) {
            $(this._element).show();
        }
    }

    /**
     * 根据文字内容大小创建文字背景 适用于文字背景
     * @param @param {[[{x,y},{x,y},{x,y},{x,y}]]} rectPeakPoints
     * @param {number} scale element dom设置的缩放比例
     * @param {number} fontSize element dom设置的文字大小
     */
    createBgElement(rectPeakPoints, scale, fontSize) {
        if (!this._element) {
            this._element = document.createElement('div');
            $(this._element).addClass('fl-text-background');
            $(this._element).css({
                position: 'absolute',
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
            });
        }

        if (!this._enabled) return;

        this.createBgSVG(rectPeakPoints, scale, fontSize);

        if (this._svgBackground) {
            this._element.innerHTML = '';
            this._element.appendChild(this._svgBackground);
        }
        this.updateStyle();
    }

    /**
     * @desc 根据矩形的顶点创建svg 背景
     * @param {[[{x,y},{x,y},{x,y},{x,y}]]} rectPeakPoints
     * @param {number} angle element dom设置的旋转角度
     * @param {number} scale element dom设置的缩放比例
     * @param {number} fontSize element dom设置的文字大小
     */
    createBgSVG(rectPeakPoints, scale, fontSize) {
        let padding = {
            left: this.padding.left,
            right: this.padding.right,
            top: this.padding.top,
            bottom: this.padding.bottom,
        };

        // 根据文字大小去设置上下行矩形的最小宽度差
        let minWidthGap = (fontSize / 115) * 80;
        let svgBackground = drawSvg(rectPeakPoints, this.radius, this.hasFollowText, padding, minWidthGap);
        this._svgBackground = svgBackground;
    }

    /**
     * @desc 通过比例等比调整背景对象的padding值
     */
    updatePaddingOfScale(scale) {
        // 更新背景的padding值
        let oldPadding = this.padding;
        let newPadding = {
            left: (oldPadding.left *= scale),
            right: (oldPadding.right *= scale),
            top: (oldPadding.top *= scale),
            bottom: (oldPadding.bottom *= scale),
        };

        this.padding = newPadding;
    }

    getBackgroundSvgPath() {
        if (this._enabled == false) return '';
        const pathElement = this._element.querySelector('svg path');
        const pathData = pathElement.getAttribute('d');
        return pathData;
    }

    drawToCanvas(ctx, offset) {
        const canvas = ctx.canvas;
        // 将文字背景渲染到指定 this._renderCanvas
        if (this._enabled && canvas) {
            const backgroundPathData = this.getBackgroundSvgPath();
            const path = new Path2D(backgroundPathData);

            ctx.save();

            if (offset) {
                const xOffset = isObject(offset) ? offset.x : offset;
                const yOffset = isObject(offset) ? offset.y : offset;
                ctx.translate(xOffset, yOffset);
            }
            ctx.fillStyle = this._color;
            ctx.fill(path);
            ctx.restore();
        }
    }

    set padding(padding) {
        this._padding = padding;
    }
    get padding() {
        return this._padding;
    }

    set radius(radius) {
        this._radius = radius;
    }
    get radius() {
        // 实际弧度于最大弧度的比例
        return this._radius;
    }

    get hasFollowText() {
        return this._hasFollowText;
    }

    set hasFollowText(hasFollowText) {
        this._hasFollowText = hasFollowText;
    }

    set enabled(enabled) {
        this._enabled = enabled;
    }
    get enabled() {
        return this._enabled;
    }
    set color(color) {
        this._color = color;
    }
    get color() {
        return this._color;
    }
    set opacity(opacity) {
        this._opacity = opacity;
    }
    get opacity() {
        return this._opacity;
    }
}

export default FJBackground;
